import { trackEvent } from 'dibs-tracking';

import { pageTypes, isPageType } from 'dibs-buyer-layout/src/entries/index';
const { PAGE_TYPE, BROWSE_TYPES } = pageTypes;

function getLabel() {
    if (isPageType(PAGE_TYPE.PDP)) {
        return 'pdp';
    } else if (isPageType(BROWSE_TYPES) || isPageType(PAGE_TYPE.DEALER)) {
        return 'search/browse';
    } else if (isPageType(PAGE_TYPE.FAVORITES)) {
        return 'my favorites';
    }
    return void 0;
}

function trackFolderEvent(action, noteIncluded = false, itemPk = null) {
    const label = getLabel();
    let eventInfo = {
        label,
        action,
        category: 'item favoriting',
        value: noteIncluded ? 1 : 0,
    };

    if (itemPk) {
        eventInfo = { ...eventInfo, additional: { itemPk } };
    }

    if (label) {
        trackEvent(eventInfo);
    }
}

export function trackFolderClick() {
    trackFolderEvent('item favoriting folder clicked');
}

export function trackItemRemoved() {
    trackFolderEvent('item removed from folder');
}

export function trackItemAdded(noteIncluded = false, itemPk = null) {
    trackFolderEvent('item added into folder', noteIncluded, itemPk);
}

export function trackFolderCreated(noteIncluded = false) {
    trackFolderEvent('item favoriting folder created', noteIncluded);
}

export default {
    trackFolderClick,
    trackItemRemoved,
    trackItemAdded,
    trackFolderCreated,
};



// WEBPACK FOOTER //
// ./assets/js/favorites/shared/folderTracking.es.js